







import { Component, Vue, Watch } from 'vue-property-decorator';
import { stringify } from 'qs';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class MessageIframe extends Vue {
  private remoteSrc = '';

  created() {
    this.setRemoteSrc();
  }

  @Watch('$route.path', { immediate: false, deep: false })
  private setRemoteSrc() {
    const { path, query } = this.$route;

    if (this.remoteSrc) {
      const { pathname } = new URL(this.remoteSrc);
      const regex = /\/member\/message\/([^/]+)/;
      const prevMatch = pathname.match(regex);
      const nextMatch = path.match(regex);

      /**
       * /member/message/something/ 하위 라우트 변경은 통합어드민 redirectTo으로 발생하는데,
       * 이는 탭이 존재하는 통합어드민 메시지통합 페이지에서 탭 변경 시 client-side 렌더링하기 위함이다.
       * 그런 경우에 iframe 주소를 유지하기 위해 예외처리한다
       */
      if (prevMatch?.[1] === nextMatch?.[1]) {
        return;
      }
    }

    this.remoteSrc = `${process.env.VUE_APP_ADMIN_REMOTE_URL}${path}${stringify({ ...query, serviceType: 'PREMIUM' }, { addQueryPrefix: true })}`;
  }
}
